import React, { useState } from "react";
import SectionContainer from "../../../Homepage/SectionContainer";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import image from "../../../assets/kangaroo/AboutBanner.png";
import { useLocation, useParams } from "react-router-dom";
import { jobs } from "../data";
import { Col, Progress, Row } from "reactstrap";
import Dropdown from "../../../component/dropdown/Dropdown";
import nepal from "../../../assets/kangaroo/nepalflag.png";
import australiaFlag from "../../../assets/kangaroo/newzealandflag.png";
import newZealandFlag from "../../../assets/kangaroo/newzealandflag.png";
import ukFlag from "../../../assets/kangaroo/newzealandflag.png";
import usaFlag from "../../../assets/kangaroo/canadaflag.png";
import chinaFlag from "../../../assets/kangaroo/newzealandflag.png";
import { Upload } from "lucide-react";
import Smallbutton from "../../../component/button/Smallbutton";
import { useQuery } from "@tanstack/react-query";
import JobListService from "../../../services/Joblist";
import JobApplicationService from "../../../services/JobApplicationService";
import "../CareerPage.css";
import { formatDate } from "../../../common/formatedate";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import FormClose from "../../../component/FormClose/FormClose";
import country from "../../../common/data/country";

const CareerDetail = () => {
  const [countryCode, setCountryCode] = useState({
    id: 6,
    label: "+61",
    flag: australiaFlag,
  });
  const [studyLevel, setStudyLevel] = useState(null);
  const [callTime, setCallTime] = useState(null);
  const [nearestOffice, setNearestOffice] = useState(null);
  const [thankYouModal, setThankYouModal] = useState(false);
  const toggleThankYou = () => setThankYouModal(!thankYouModal);
  const { jobTitle } = useParams();
  console.log(jobTitle);

  const fetchjobData = async (id) => {
    const response = await JobListService.getbyId(id);
    return response;
  };

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const refValue = params.get("ref").replace(/\)$/, "");

  const {
    isPending,
    error,
    data: jobDetail,
  } = useQuery({
    queryKey: ["jobData", jobTitle],
    queryFn: () => fetchjobData(jobTitle),
  });

  const validationSchema = Yup.object({
    fullName: Yup.string().required("Full Name is required"),
    permanentAddress: Yup.string().required("Permanent Address is required"),
    localAddress: Yup.string().required("Local Address is required"),
    email: Yup.string()
      .trim()
      .required("Email address is required")
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
        "Please enter a valid email address"
      )
      .max(254, "Email address is too long"),
    phoneNumber: Yup.string()
      .transform((value) => (value ? String(value) : "")) // ensure it's a string
      .matches(/^[0-9]+$/, "Phone number must contain only numbers") // no letters/special chars
      .min(10, "Phone number must be at least 10 digits") // minimum 10 digits
      .required("Phone number is required"),
    cv: Yup.mixed()
      .required("CV is required")
      .test("fileType", "Only PDF files are allowed", (value) => {
        return value && value.type === "application/pdf";
      }),
  });

  // Custom submit handler with detailed console logs
  const handleCustomSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      // console.log('=== FORM SUBMISSION STARTED ===');
      // console.log('Timestamp:', new Date().toISOString());

      // // Log form values
      // console.log('\n--- Form Values ---');
      // console.log('Full Name:', values.fullName);
      // console.log('Permanent Address:', values.permanentAddress);
      // console.log('Local Address:', values.localAddress);
      // console.log('Email:', values.email);
      // console.log('Phone Number:', values.phoneNumber);
      // console.log('Country Code:', countryCode.label);

      // // Log CV file details
      // console.log('\n--- CV File Details ---');
      // if (values.cv) {
      //   console.log('File Name:', values.cv.name);
      //   console.log('File Type:', values.cv.type);
      //   console.log('File Size:', (values.cv.size / 1024).toFixed(2), 'KB');
      //   console.log('Last Modified:', new Date(values.cv.lastModified).toLocaleString());
      // }

      // Create FormData for multipart/form-data
      const formData = new FormData();
      formData.append("fullName", values.fullName);
      formData.append("permanentAddress", values.permanentAddress);
      formData.append("localAddress", values.localAddress);
      formData.append("email", values.email);
      formData.append("phoneNumber", values.phoneNumber);
      // formData.append('countryCode', countryCode.label);
      formData.append("jobTitle", jobDetail?.position);
      formData.append("jobListingId", jobDetail?.id || "");
      formData.append("submittedAt", new Date().toISOString());

      // Append the CV file
      if (values.cv) {
        formData.append("ResumeFile", values.cv);
      }

      console.log("\n--- FormData Contents ---");
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          console.log(
            `${key}:`,
            `[File: ${value.name}, ${(value.size / 1024).toFixed(2)} KB]`
          );
        } else {
          console.log(`${key}:`, value);
        }
      }

      // Send to API
      console.log("\n--- Sending to API ---");
      const response = await JobApplicationService.create(formData);

      console.log("\n--- API Response ---");
      console.log("Response:", response);

      console.log("\n=== FORM SUBMISSION COMPLETED SUCCESSFULLY ===");

      // Reset form after successful submission
      resetForm();
      setCountryCode({ id: 6, label: "+61", flag: australiaFlag });
      toggleThankYou();
    } catch (error) {
      console.error("\n=== FORM SUBMISSION ERROR ===");
      console.error("Error Message:", error.message);
      console.error("Error Details:", error);
    } finally {
      setSubmitting(false);
    }
  };

  console.log(jobDetail);

  const totalDays = 30;
  const progressValue = ((totalDays - jobDetail?.daysLeft) / totalDays) * 100;

  return (
    <>
      <div
        className="hero-banner"
        style={{ "--banner-img": `url(${refValue})` }}
      >
        <SectionContainer>
          <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "CORPORATE", link: "/about" },
              { title: "CAREER" },
            ]}
            instituition={true}
          />
          <div className=" w-100 d-flex justify-content-start align-items-center">
            <h1 className="font-level-4 lh-1">
              FIND YOUR <br /> OPPORTUNITY{" "}
            </h1>
          </div>
        </SectionContainer>
      </div>
      <SectionContainer>
        <Row>
          <Col>
            <h1
              className="career-sub-heading pb-4"
              style={{ marginTop: "6rem" }}
            >
              {jobDetail?.position}
            </h1>
            <Progress
              value={progressValue}
              className="mb-3 custom-progress"
              style={{ height: "10px", width: "100%" }}
            />
            <p
              className="country-paragraph-text"
              style={{ marginBottom: "2rem" }}
            >
              {jobDetail?.daysLeft} Day(s) left
            </p>
            <p className="career-desc-font">
              Positions:{" "}
              <span className="career-desc-font fw-bold">
                {jobDetail?.position}
              </span>
            </p>
            <p className="career-desc-font">
              Published Date:{" "}
              <span className="career-desc-font fw-bold">
                {formatDate(jobDetail?.publishedDate)}
              </span>
            </p>
            <p className="career-desc-font" style={{ marginBottom: "3rem" }}>
              Deadline:{" "}
              <span className="career-desc-font fw-bold">
                {formatDate(jobDetail?.deadline)}
              </span>{" "}
            </p>
            <p className="event-city fw-bold m-0">
              Job Description: <br /> <br />
            </p>
            <p
              className="career-desc-font mb-5"
              dangerouslySetInnerHTML={{ __html: jobDetail?.jobDescription }}
            ></p>
            <p className="event-city fw-bold m-0">
              Job Specification: <br /> <br />
            </p>
            <p
              className="career-desc-font mb-5"
              dangerouslySetInnerHTML={{ __html: jobDetail?.jobSpecifications }}
            ></p>
            <p className="event-city fw-bold m-0">
              Experience: <br /> <br />
            </p>
            <p
              className="career-desc-font mb-5"
              dangerouslySetInnerHTML={{ __html: jobDetail?.experience }}
            ></p>
            <p className="event-city fw-bold m-0">
              Education and Qualification: <br /> <br />
            </p>
            <p className="career-desc-font mb-5">{jobDetail?.education}</p>
          </Col>

          <p className="event-city fw-bold m-0">
            Apply
            <br /> <br />
          </p>
        </Row>
        <Formik
          initialValues={{
            fullName: "",
            permanentAddress: "",
            localAddress: "",
            email: "",
            phoneNumber: "",
            cv: null,
            message: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleCustomSubmit}
        >
          {({
            setFieldValue,
            values,
            handleSubmit,
            isSubmitting,
            touched,
            errors,
            handleChange,
            handleBlur,
          }) => (
            <form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <div>
                    <label htmlFor="fullName" className="font-label">
                      Full Name*
                    </label>
                    <Field
                      type="text"
                      className="form-control form-box py-3"
                      id="fullName"
                      name="fullName"
                    />
                    <ErrorMessage
                      name="fullName"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div>
                    <label htmlFor="permanentAddress" className="font-label">
                      Permanent Address*
                    </label>
                    <Field
                      type="text"
                      className="form-control form-box py-3"
                      id="permanentAddress"
                      name="permanentAddress"
                    />
                    <ErrorMessage
                      name="permanentAddress"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div>
                    <label htmlFor="localAddress" className="font-label">
                      Local Address*
                    </label>
                    <Field
                      type="text"
                      className="form-control form-box py-3"
                      id="localAddress"
                      name="localAddress"
                    />
                    <ErrorMessage
                      name="localAddress"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div>
                    <label htmlFor="email" className="font-label">
                      Email Address*
                    </label>
                    <Field
                      type="email"
                      className="form-control form-box py-3"
                      id="email"
                      name="email"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div>
                    <label htmlFor="phoneNumber" className="font-label">
                      Phone Number*
                    </label>
                    <div
                      className="d-flex justify-content-center align-items-start position-relative"
                      style={{
                        borderRadius: "8px",
                        transition: "box-shadow 0.2s ease-in-out",
                        border:
                          errors.phoneNumber || errors.countryCode
                            ? ""
                            : "none", // highlight border if error
                      }}
                      onFocus={(e) => {
                        e.currentTarget.style.boxShadow =
                          "0 0 0 4px rgba(13, 110, 253, 0.25)";
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      <div style={{ flex: "0 0 6rem" }}>
                        <Dropdown
                          items={country.map((item) => ({
                            id: item.id,
                            label: item.countryCode,
                            flag: item.flagImg,
                          }))}
                          width="9rem"
                          selectedItem={countryCode}
                          setSelectedItem={(item) => {
                            setCountryCode(item);
                            setFieldValue("countryCode", item?.label || null);
                          }}
                          phoneNumber={true}
                          placeholder="+61"
                          placeholderFlag={australiaFlag}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <Field
                          type="number"
                          name="phoneNumber"
                          value={values.phoneNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="form-control form-box py-3"
                          style={{
                            borderLeft: "0",
                            borderTop: "2px solid #687C86",
                            borderRight: "2px solid #687C86",
                            borderBottom: "2px solid #687C86",
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            borderTopLeftRadius: "0",
                            borderBottomLeftRadius: "0",
                            boxSizing: "border-box",
                            paddingLeft: "12px",
                            width: "100%",
                            outline: "none",
                            boxShadow: "none",
                          }}
                        />
                      </div>
                    </div>

                    {/* Show error for the whole component */}
                    {(touched.phoneNumber && errors.phoneNumber) ||
                      (touched.countryCode && errors.countryCode) ? (
                      <div
                        className="text-danger mt-1"
                        style={{ fontSize: "0.875rem" }}
                      >
                        {touched.countryCode && errors.countryCode
                          ? errors.countryCode
                          : touched.phoneNumber && errors.phoneNumber
                            ? errors.phoneNumber
                            : null}
                      </div>
                    ) : null}
                  </div>
                </Col>
                <Col sm={12} key="message">
                  <div>
                    <label htmlFor="message" className="font-label">
                      Message (if any)
                    </label>
                    <Field
                      as="textarea"
                      name="message"
                      className={`form-control form-height form-box ${touched.message && errors.message ? "is-invalid" : ""
                        }`}
                      id="message"
                      rows={4}
                      style={{ resize: "vertical" }}
                    />
                    <ErrorMessage
                      name="message"
                      component="div"
                      className="text-danger mt-1"
                      style={{ fontSize: "0.875rem" }}
                    />
                  </div>
                </Col>
              </Row>

              <div
                className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center"
                style={{ marginBottom: "15.5rem", marginTop: "2rem" }}
              >
                {/* Upload CV */}
                <div>
                  <div
                    style={{ backgroundColor: "#687c86", cursor: "pointer" }}
                    className="d-flex justify-content-start px-3 align-items-center rounded gap-3"
                    onClick={() => document.getElementById("cvUpload").click()}
                  >
                    <Upload />
                    <p
                      className="career-upload-font m-0"
                      style={{ padding: "1.081rem 0" }}
                    >
                      {values.cv ? values.cv.name : "Upload your CV*"}
                    </p>
                  </div>

                  <input
                    id="cvUpload"
                    type="file"
                    accept=".pdf"
                    style={{ display: "none" }}
                    onChange={(e) => setFieldValue("cv", e.target.files[0])}
                  />
                  <ErrorMessage
                    name="cv"
                    component="div"
                    className="text-danger"
                  />
                </div>

                {/* Apply Button */}
                <div className="mt-3 mt-md-0">
                  <button
                    type="submit"
                    style={{ border: "none", background: "none", padding: 0 }}
                    disabled={isSubmitting}
                  >
                    <Smallbutton
                      width="250px"
                      text={isSubmitting ? "SUBMITTING..." : "APPLY"}
                    />
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
        <FormClose
          modal={thankYouModal}
          toggle={toggleThankYou}
          heading="Thank You For Applying"
          description="We have received your application and will get back to you as soon as possible."
        />
      </SectionContainer>
    </>
  );
};

export default CareerDetail;
